// (C) Copyright 2024 Hewlett Packard Enterprise Development LP

export const WORKSPACE_TYPE = Object.freeze({
  STANDALONE: 'STANDALONE',
  MSP: 'MSP'
})
